import { NextSeo } from "next-seo";
import { ReactElement } from "react";
import ServiceSelector from "~/components/ServiceSelector";
import { MainLayout } from "~/components/layouts/MainLayout";
import { MarginLayout } from "~/components/layouts/MarginLayout";
import { NextPageWithLayout } from "~/pages/_app";

const BookPage: NextPageWithLayout = () => {
  return (
    <MarginLayout>
      <ServiceSelector />
    </MarginLayout>
  );
};

BookPage.getLayout = function GetLayout(page: ReactElement) {
  return (
    <MainLayout>
      <NextSeo
        title="Zarezerwuj przegląd — wybierz usługę i miasto"
        description="Wybierz kategorię, usługę i miasto, aby przejść do właściwej strony usługi lub lokalnych wyników."
      />
      {page}
    </MainLayout>
  );
};

export default BookPage;
